import React, { ChangeEvent, useState, useEffect, useRef } from "react";
interface TopContentProps {}

const TopContent: React.FC<TopContentProps> = ({}) => {
  const renderContent = () => {
    return (
      <div className="top-content">
        <h1>Welcome to Leonard Bay</h1>
        <p>Enjoy your visit!</p>
      </div>
    );
  };

  return <div>{renderContent()}</div>;
};

export default TopContent;
